<template>
  <component :is="aOrLink" v-bind="linkAttrs">
    <slot />
  </component>
</template>
<script lang="ts" setup>
import {computed} from 'vue';
import {Link} from '@inertiajs/vue3';

const {href, external, target, prefetch} = defineProps<{
  href: string;
  prefetch?: boolean;
  external?: boolean;
  target?: '_blank' | '_parent' | '_self' | '_top' | string;
}>();

const linkAttrs = computed(() => ({
  href,
  target: external && target ? target : undefined,
  rel: external && target == '_blank' ? 'noopener noreferrer' : undefined,
  prefetch,
}));

const aOrLink = computed(() => (external ? 'a' : Link));
</script>
